export enum CookieKey {
    JWT_TOKEN = 'jwt_token',
    REFRESH_TOKEN = 'refresh_token',
    USER_PHONE = 'user_phone',
    USER_NAME = 'user_name',
}
